// extracted by mini-css-extract-plugin
export default {"error":"vendorNumberSelectField_error__kwIGI"};